import * as React from "react";

import { IDayCell_MonthMobile, IDayCellSlot_MonthMobile } from "../../../classes/dayCell_MonthMobile";
import { IText } from "../../../classes/Text";

import { MonthDayNumber } from "../MonthlyEventView/MonthDayNumber";
import { MonthListEvents } from "./MonthListEvents";

import * as dates from "../../../reducers/changeTimePeriod";

import debounce from "lodash.debounce";

import { scrollToSelectedDate, scrollToTabbedDate } from "../../../scripts/calendarJQueryScript";

export interface IMonthListItemProps {
    dayCell: IDayCell_MonthMobile;
    currentDate: Date;
    selectedDate: Date;
    todaysDate: Date;
    text: IText;
    contextId: number;
    pageId: number;
    parentId: number;
    portalId: number;
    portletInstanceId: number;
    userDateFormat: string;
    viewMode: string;
    onStartAjaxCall: (event: any) => any;
    onSetCurrentDate: (event: any) => any;
    onSetEventId: (event: any) => any;
    onSetEventScreenMode: (eventScreenMode: string) => any;
    onSetSelectedDate: (event: any) => any;
    onSetiCalStartDate: (event: any) => any;
    onSetDisplayedEventLocalStartDate: (localStartDate: Date) => any;
    onSetDisplayedEventLocalEndDate: (localEndDate: Date) => any;
    onSetViewMode: (event: any) => any;
}

export const MonthListDay = (props: IMonthListItemProps) => {

    let liClass = "CAL-V-MV-row";
    if (dates.isSameDay(props.dayCell.date, props.todaysDate)) {
        liClass += " CAL-V-today";
    }

    const cellDateShort = dates.formatYearMonthDayNoSeperator(props.dayCell.date);
    let selectedClass = "CAL-V-MV-selectDay cell" + cellDateShort; // cellDateShort is used to id the row in calendarJQueryScript.
    if (dates.isSameDay(props.dayCell.date, props.selectedDate)) {
        selectedClass += " CAL-V-MV-SD-selected";
    }

    const onClickDayRow = (e) => {
        props.onSetSelectedDate(e);
        scrollToSelectedDate(props.portletInstanceId);
    };

    const onKeyDownRow = (e) => { // For TABing to row, need to scroll to item that was tabbed to.
        if (e.keyCode === 9) {
            scrollToTabbedDate(props.portletInstanceId, e);
        }
    };

    const cellDateFull = props.dayCell.date.toString();

    return (
        <li className={liClass} key={dates.getDayOfMonth(props.dayCell.date)}>
            <a href="#!" className={selectedClass} aria-hidden="true" onClick={onClickDayRow} onKeyDown={onKeyDownRow} data-date={cellDateFull} data-date-short={cellDateShort}></a>
            <div className="CAL-V-MV-itemW">
                <MonthDayNumber
                    date={props.dayCell.date}
                    numberOfEvents={props.dayCell.totalNumberEvents}
                    onSetViewMode={props.onSetViewMode}
                    onSetCurrentDate={props.onSetCurrentDate}
                    isMobileMode={true}
                />
                <div>
                    <MonthListEvents
                        dayCell={props.dayCell}
                        text={props.text}
                        contextId={props.contextId}
                        selectedDate={props.selectedDate}
                        pageId={props.pageId}
                        parentId={props.parentId}
                        portalId={props.portalId}
                        portletInstanceId={props.portletInstanceId}
                        userDateFormat={props.userDateFormat}
                        viewMode={props.viewMode}
                        todaysDate={props.todaysDate}
                        onStartAjaxCall={props.onStartAjaxCall}
                        onSetCurrentDate={props.onSetCurrentDate}
                        onSetEventId={props.onSetEventId}
                        onSetEventScreenMode={props.onSetEventScreenMode}
                        onSetiCalStartDate={props.onSetiCalStartDate}
                        onSetDisplayedEventLocalStartDate={props.onSetDisplayedEventLocalStartDate}
                        onSetDisplayedEventLocalEndDate={props.onSetDisplayedEventLocalEndDate}
                        onSetViewMode={props.onSetViewMode}
                    />
                </div>
            </div>
        </li>
    );
};
